const refNoModuleMap: { [key: string]: string } = {
    GR: 'grievances',
};

export function refNoToModuleId(refNo: string) {
    const modulePart = refNo.split('-')[0];
    if (refNoModuleMap[modulePart]) {
        return refNoModuleMap[modulePart];
    } else {
        throw new Error(`Could not convert refNo to moduleId [${refNo}]`);
    }
}

export function normalizeRefNo(refNo: string) {
    const [prefix, id] = refNo.split('-');
    if (!prefix || !id) {
        return refNo;
    }
    return `${prefix.toUpperCase()}-${id.padStart(5, '0')}`;
}
